// @flow
import React from "react";
import { useTranslation } from "react-i18next";
import { List } from "semantic-ui-react";

import { ExpandableSegment } from "Commons/Components";
import { formatConsumption, formatCurrency } from "modules/Offers/misc/Utils";

import type { OfferT } from "modules/Offers/misc/Types";
import type { ReminderT } from "modules/Reminder/misc/Types";
import TariffRow from "./TariffRow";

import Styles from "./TariffComparison.module.scss";

type Props = {
  reminder: ReminderT,
  offer: OfferT,
  category: string,
};

const OldTariff = ({ reminder, offer, category }: Props) => {
  const { t } = useTranslation("offerPageDetail");
  const remindMeBonus = offer?.remindMeBonus;
  const _savings = remindMeBonus?.amount ? remindMeBonus.totalSaving : offer?.gasElectricityDetails?.savings || 0;

  const newBenchmarkFactor = category === "strom" ? 1.3 : 2;

  const negativeSavingBenchmark = offer?.gasElectricityDetails?.benchmarkTariffTotalCostInEuro
    ? offer.gasElectricityDetails.benchmarkTariffTotalCostInEuro * newBenchmarkFactor
    : 0;

  return (
    <ExpandableSegment
      toggleOnHeaderClick
      attached
      className={Styles.tariff}
      header={
        <div className={Styles.tariffHeader}>
          <List>
            <TariffRow
              labelBold
              label={t(`tariffsComparison.${_savings < 0 ? "olderTariffForNegativeSavings" : "olderTariff"}`)}
              value={
                _savings <= 0
                  ? `${formatCurrency(negativeSavingBenchmark)} / Jahr`
                  : `${formatCurrency(offer.gasElectricityDetails?.benchmarkTariffTotalCostInEuro || 0)} / Jahr`
              }
            />
          </List>
        </div>
      }
    >
      <List>
        <TariffRow label={t("specialOffer:offer.provider")} value={reminder.companyName} />
        <TariffRow label={t("specialOffer:offer.tariff")} value={reminder.tariffName} />
        <TariffRow label={t("specialOffer:offer.demand")} value={formatConsumption(reminder)} />
        <TariffRow
          label={t("specialOffer:offer.yearlyCosts")}
          value={formatCurrency(offer.gasElectricityDetails?.benchmarkTariffTotalCostInEuro || 0)}
        />
      </List>
    </ExpandableSegment>
  );
};

export default OldTariff;
